<template>
    <div><!--  slot="textCard__Text" -->
        <br />
        <span class="comparison"  v-if="levelIndustry && levelIndustry > 0.8">
            Andere <strong>Unternehmen Ihrer Branche</strong> haben durchschnittlich einen KI-Readiness-Level von <span
                style="font-weight: bold;">{{ levelIndustry }} Sternen erreicht: </span><br />
            <div class="stars-wrapper">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry >= 0.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry >= 1.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry >= 2.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry >= 3.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry >= 4.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry < 1.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry < 2.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry < 3.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry < 4.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelIndustry < 0.5"><br />
            </div>
        </span>
        <span class="comparison" v-else>
            Es gibt nicht genügend Unternehmen in Ihrer Branche, um einen Vergleich zu ziehen.
        </span>
        <br />
        <span class="comparison"  v-if="levelSize && levelSize > 0.2">
            Andere <strong>Unternehmen Ihrer Größe</strong> haben durchschnittlich einen KI-Readiness-Level von <span
                style="font-weight: bold;">{{ levelSize }} Sternen erreicht: </span><br />
            <div class="stars-wrapper">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelSize >= 0.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelSize >= 1.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelSize >= 2.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelSize >= 3.5">
                <img class="star-small" src="../../../../assets/star.svg" alt="Star" width="15" height="15"
                    v-if="levelSize >= 4.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelSize < 1.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelSize < 2.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelSize < 3.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelSize < 4.5">
                <img class="star-small" src="../../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                    v-if="levelSize < 0.5"><br />
            </div>
        </span>
        <span class="comparison" v-else>
            Es gibt nicht genügend Unternehmen in Ihrer Unternehmensgröße, um einen Vergleich zu ziehen.
        </span>
        <span style="font-size: small;">Basiert auf Auswertung von insgesamt {{ amountCompaniesComparison }}
            Unternehmen.</span>
    </div>
</template>

<script>
export default {
    props: {
        levelIndustry: {
            type: Number,
            default: 0
        },
        levelSize: {
            type: Number,
            default: 0
        },
        amountCompaniesComparison: {
            type: Number,
            default: 0
        },
        starclass: {
            type: String,
            default: "star-small",
        },
        size: {
            type: Number,
            default: 15,
        },
    },
    data() {
        return {
            level1: {
                name: "Novize",
                text:
                    "Voraussetzungen für den Einsatz von KI-Anwendungen sind noch keine erfüllt. Es wurden noch keine KI-Anwendungsszenarien identifiziert. Das Thema KI wird im Unternehmen noch nicht wahrgenommen, auch über eine KI-Strategie hat man sich noch keine Gedanken gemacht. Daten werden in der Regel nur vereinzelt digital erfasst."
            },
            level2: {
                name: "Erkunder",
                text:
                    "Voraussetzungen für den Einsatz von KI-Anwendungen wurden identifiziert und Potenziale möglicher Anwendungen wurden erkannt. Die Mitarbeiter des Unternehmens beginnen sich für das Thema KI zu interessieren. Perspektivisch soll eine KI-Strategie eingeführt werden. Daten werden in der Regel noch unstrukturiert und dezentral erfasst. Notwendige Kompetenzen zum Umgang mit KI-Anwendungen wurden identifiziert."
            },
            level3: {
                name: "Entdecker",
                text:
                    "Maßnahmen zur Erfüllung der Voraussetzungen für die KI-Einführung wurden identifiziert. Konkrete Anwendungsszenarien wurden bereits erfasst und die Bereitschaft von Mitarbeitern KI-Projekte mitzutragen ist vereinzelt gegeben. Eine KI-Strategie ist in Planung. Daten werden bereits strukturiert, aber dezentral, erfasst. Die Mitarbeiter des Unternehmens werden beim Kompetenzaufbau im Bereich KI unterstützt."
            },
            level4: {
                name: "Vorbereiter",
                text:
                    "Maßnahmen, um die Voraussetzungen für KI-Anwendungen zu erfüllen wurden ergriffen. Es wurden konkrete Lösungsansätze für die identifizierten Anwendungsszenarien beschlossen. Die Bereitschaft der Mitarbeiter KI-Projekte mitzugestalten ist vorhanden und die Planung einer KI-Strategie ist abgeschlossen. Daten werden in der Regel zentral und größtenteils strukturiert erfasst. Ein erweitertes Angebot für den Kompetenzaufbau der Mitarbeiter ist vorhanden und wird gegebenenfalls durch die Akquise neuer Mitarbeiter unterstützt."
            },
            level5: {
                name: "Anwender",
                text:
                    "Die Voraussetzungen für den Einsatz von KI-Anwendungen sind erfüllt und die Umsetzung vereinzelter Anwendungsszenarien läuft. Die Mitarbeiter des Unternehmens sind motiviert KI-Projekte voranzutreiben. Die Umsetzung der KI-Strategie ist bereits angelaufen. Daten werden zentral gespeichert und es werden erste Analysen durchgeführt. Ein individueller Kompetenzaufbau im Bereich KI wird gefördert."
            },
        };
    },
    computed: {
        levelData() {
            return [this.level1, this.level2, this.level3, this.level4, this.level5];
        }
    }

};
</script>

<style scoped>
.levelSubheading {
    font-weight: bold;
}

.stars-wrapper {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.star {
    transition: transform 0.3s;
}

.star:hover {
    transform: scale(1.1);
}

.finalScoreWrapper {
    text-align: center;
}

.md-card-content {
    padding: 20px;
}

.comparison {
    display: block;
    text-align: justify;
    font-size: 0.9em;
}
</style>


// WEBPACK FOOTER //
// src/components/company/kirc/components/Comparison.vue